<section
  *ngIf="isVisible"
  class="funding-visibility"
  [ngClass]="'funding-visibility--' + placement"
  role="complementary"
  [attr.aria-label]="ariaLabel"
>
  <button
    *ngIf="pdfUrl"
    type="button"
    class="funding-visibility__button"
    [attr.aria-label]="buttonLabel"
    (click)="openPdf()"
  >
    <img
      class="funding-visibility__logo"
      [src]="logoFrameSrc"
      alt=""
      loading="eager"
      decoding="async"
    />
  </button>

  <span *ngIf="!pdfUrl" class="funding-visibility__static">
    <img
      class="funding-visibility__logo"
      [src]="logoFrameSrc"
      alt=""
      loading="eager"
      decoding="async"
    />
  </span>

  <!-- Logo frames are decorative (alt=""); this statement is the single announcement. -->
  <span class="funding-visibility__sr-only">{{ screenReaderText }}</span>
</section>
